// Bloque de controles (sticky, ver .cab-stk en cabrillo-nativo.css).
// Equivalente a: $("play")/$("all")/$("spd")/$("clock")/$("sl") + $("bf")
// (botones de filtro de banda) + drawMini() del original
// (public/cabrillo/src/plantilla.html:86,88,114-117,133-134). Ver
// src/cabrillo/CREDITOS.md.
//
// render ≠ motor: este módulo solo lee motor.obtenerEstado()/estadisticas()
// y traduce clics a llamadas de motor.js (irA/avanzar/filtrarBanda/
// reproducir/pausar/fijarVelocidad). No recalcula nada analítico.

import { bl } from '../geo.js';
import { BC, fmt, css, observarRedimension } from './render-util.js';

/**
 * @param {object} els - referencias DOM: play, all, spd, clock, sl, bf, mini
 * @param {ReturnType<import('../motor.js').crearAnalizador>} motor
 */
export function montar(els, motor) {
    const { bands, NB } = motor.modelo;

    // ---- filtro de banda: botones "Todas" + una por banda ----
    els.bf.innerHTML = ['Todas', ...bands.map(bl)]
        .map((t, i) => `<button data-b="${i - 1}" class="${i ? '' : 'cab-p'}" style="${i ? `border-left:4px solid ${BC(i - 1)}` : ''}">${t}</button>`)
        .join('');
    els.bf.onclick = (e) => {
        const b = e.target.dataset.b;
        if (b !== undefined) motor.filtrarBanda(+b < 0 ? null : +b);
    };

    // ---- slider ----
    els.sl.min = 0;
    els.sl.max = NB - 1;
    els.sl.oninput = (e) => {
        motor.pausar();
        motor.irA(+e.target.value);
    };

    // ---- play / pausa / velocidad ----
    els.play.onclick = () => {
        if (motor.estaReproduciendo()) motor.pausar();
        else motor.reproducir();
    };
    els.spd.onchange = () => motor.fijarVelocidad(parseFloat(els.spd.value));

    // ---- ver todo ----
    els.all.onclick = () => {
        motor.pausar();
        motor.verTodo();
    };

    // ---- mini scrubber (canvas) ----
    const mc = els.mini.getContext('2d');
    els.mini.onclick = (e) => {
        const b = els.mini.getBoundingClientRect();
        motor.pausar();
        motor.irA(Math.max(0, Math.min(NB - 1, Math.floor(((e.clientX - b.left) / b.width) * NB))));
    };

    function drawMini() {
        const { D } = motor.modelo;
        const { cur, bf } = motor.obtenerEstado();
        const dpr = devicePixelRatio || 1;
        const W = els.mini.clientWidth;
        if (W === 0) return; // aún sin layout válido; el ResizeObserver vuelve a llamar cuando lo tenga
        const H = 34;
        const a = Array(NB).fill(0);
        D.forEach((r) => {
            if (bf < 0 || r[1] === bf) a[r[0]]++;
        });
        const mx = Math.max(1, ...a);
        const bw = W / NB;
        els.mini.style.height = H + 'px';
        els.mini.width = W * dpr;
        els.mini.height = H * dpr;
        mc.setTransform(dpr, 0, 0, dpr, 0, 0);
        mc.fillStyle = css(els.mini, '--acc');
        for (let i = 0; i < NB; i++) {
            mc.globalAlpha = i <= cur ? 0.9 : 0.25;
            const h = (a[i] / mx) * (H - 4);
            mc.fillRect(i * bw, H - h, Math.max(bw - 0.5, 0.8), h);
        }
        mc.globalAlpha = 1;
        mc.fillStyle = css(els.mini, '--fg');
        mc.fillRect(Math.min((cur + 1) * bw, W - 2), 0, 2, H);
    }

    function actualizar() {
        const { cur, bf, reproduciendo } = motor.obtenerEstado();
        els.play.textContent = reproduciendo ? '❚❚ Pausa' : '▶ Reproducir';
        els.sl.value = cur;

        [...els.bf.children].forEach((x) => x.classList.toggle('cab-p', +x.dataset.b === bf));

        const { totalQso } = motor.estadisticas();
        els.clock.textContent =
            fmt(motor.modelo.t0 + cur * 6e5) + ' UTC · ' + totalQso + ' QSO' + (bf >= 0 ? ' en ' + bl(bands[bf]) : '');

        drawMini();
    }

    actualizar();
    const desuscribir = motor.subscribe(actualizar);
    const dejarDeObservar = observarRedimension(els.mini, actualizar);

    return {
        actualizar,
        destruir() {
            desuscribir();
            dejarDeObservar();
        },
    };
}
